import { request } from '../request';
import { uploadRequest } from '../upload-request';

/**
 * 获取视频详情
 * @param {Object} id 课程id
 */
export function fetchCourseIntroDetails(params) {
  return request.post('/course/getVideoCourseDetail/', params);
}

/**
 * 获取课程详情评论列表
 * @param {Object} params params
 */
export function fetchCourseCommentList(params) {
  return request.post('/course/getCourseCommentByPage/', params);
}
/**
 * 获取单条评论及其所有子评论
 * @param {Object} params params
 */
export function fetchCommentAndChildren(params) {
  return request.post('/course/getCommentAndChildren/', params);
}
/**
 * 获取评论定位
 * @param {Object} params params
 */
export function fetchCourseCommentLocate(params) {
  return request.post('/course/getCourseCommentLocationByCommentId/', params);
}

/**
 * 获取公共评论（视频、教学贴、常见问题、百科评论）
 * @param {Object} params params
 */
export function fetchPublicCommentList(params) {
  return request.post('/course/listCommentByPage/', params);
}

/**
 * 获取课程目录详情
 * @param {Object} id 课程id
 */
export function fetchCourseDirDetails(params) {
  return request.post('/course/getFineCourseDetail', params);
}

/**
 * 点赞课程评论
 * @param {Object} params 评论参数
 */
export function queryCourseCommentLike(params) {
  return request.post('/course/addLikeComment/', params);
}

/**
 * 删除课程评论
 * @param {Object} params 删除评论参数
 */
export function deleteCourseComment(params) {
  return request.post('/course/deleteCourseComment', params);
}

/**
 * 获取直播回看详情
 * @param {Object} params 直播课程id
 */
export function fetchLiveDetails(params) {
  return request.post('/course/getListTeachCastDetail', params);
}

/**
 * 获取课程专栏详情
 * @param {Object} params 课程id
 */
export function fetchCourseColumnDetails(params) {
  return request.post('/course/getCourseThemeDetail', params);
}

/**
 * 获取行业百科详情
 * @param {Object} params choppId
 */
export function fetchBaikeDetails(params) {
  return request.post('/course/getChoppById', params);
}

/**
 * 获取图文教程详情
 * @param {Object} params id
 */
export function fetchTutorialDetails(params) {
  return request.post('/course/getImgCourseDetail', params);
}

/**
 * 统计付费视频播放记录
 * @param {Object} params params
 */
export function fetchPaidCoursePlayRecord(params) {
  return request.post('/course/updateCourseVideoViewRecord', params);
}

// 列表接口【1.13.0新增】
/**
 * 获取课程目录分类
 * @param {Object} params params
 */
export function fetchCourseCategories() {
  return request.get('/category/getCourseCategories');
}

/**
 * 分页查询课程列表
 * @param {Object} params params
 */
export function fetchCourseList(params) {
  return request.post('/course/listCoursesByPage', params);
}

/**
 * 获取图文教程之教学贴的目录
 * @param {Object} params params
 */
export function fetchImgCourseList(params) {
  return request.post('/course/getImgCourse', params);
}

/**
 * 获取图文教程之常见问题的目录
 * @param {Object} params params
 */
export function fetchImgCourseFaqList(params) {
  return request.post('/course/getImgCourseFaq', params);
}

/**
 * 获取行业百科列表
 * @param {Object} params params
 */
export function fetchChoppList(params) {
  return request.post('/course/getChopp', params);
}

/**
 * 创建课程订单
 * @param {Object} params params
 */
export function createOrder(params) {
  return request.post('/course/createOrder', params);
}

/**
 * 分页获取个人购买的课程
 * @param {Object} params params
 */
export function fetchPurchasedCourse(params) {
  return request.post('/course/getPurchasedCourse', params);
}

/**
 * 分页获取收藏课程
 * @param {Object} params params
 */
export function fetchFavoriteCourse(params) {
  return request.post('/course/getFavoriteCourseByPage', params);
}

/**
 * 取消收藏课程
 * @param {Object} params params
 */
export function cancelFavoriteCourse(params) {
  return request.post('/course/cancelFavorite', params);
}

/**
 * 收藏课程
 * @param {Object} params params
 */
export function favoriteCourse(params) {
  return request.post('/course/favoriteCourse', params);
}

/**
 * 添加直播回放数据
 * @param {Object} params params
 */

export function addLiveBack(params) {
  return uploadRequest.post('/platform-portal/api/study/living/addLiveReplayData', params);
}
